import { useTranslation } from 'react-i18next';

import { Anchor, Image, Stack } from '@myphx-engineering/phx-design-system';
import { useDisclosure } from '@myphx-engineering/phx-design-system/hooks';

import externalRoutes from '../../external-routes';

import { PrescryptivePoweredModal } from './PrescryptivePoweredModal';

export const PrescryptivePowered = ({
    isUnauthHome,
}: {
    isUnauthHome?: boolean;
}) => {
    const [opened, { toggle }] = useDisclosure(false);
    const { t } = useTranslation();

    return (
        <Stack
            gap="xxs"
            style={{ cursor: 'pointer' }}
            onClick={toggle}
            align="center"
            justify="center"
        >
            <span>
                <Image
                    src="/static/img/prescryptive-powered-logo.svg"
                    alt="logo"
                    width="auto"
                    height={isUnauthHome ? '46' : '26'}
                    fit="contain"
                />
            </span>
            {isUnauthHome && (
                <Anchor
                    color="black"
                    href={externalRoutes.termsConditions}
                    target="_blank"
                >
                    {t('prescryptivePowered.termsAndConditions')}
                </Anchor>
            )}
            <PrescryptivePoweredModal opened={opened} toggle={toggle} />
        </Stack>
    );
};
